import React from "react";
import { Link } from "react-router-dom";

export class Footer extends React.Component {
  render() {
    return (
      <footer className="py-2 mt-4">
        <ul className="lg:text-sm flex justify-center space-x-4">
          <li>
            <Link to="/datenschutzerklaerung" className="hover:underline text-primary">
              Datenschutzerklärung
            </Link>
          </li>
          <li>
            <Link to="/impressum" className="hover:underline text-primary">
              Impressum
            </Link>
          </li>
          <li>
            <Link to="/contact" className="hover:underline text-primary">
              Contact us
            </Link>
          </li>
        </ul>
      </footer>
    );
  }
}

export default Footer;
